export enum TipoPessoaEnum {
  Fisica = 1,
  Juridica = 2,
  Estrangeiro = 3,
}
